/**
 * An object containing properties for filter events
 */
var FilterEvent = /** @class */ (function () {
    function FilterEvent() {
    }
    return FilterEvent;
}());
export { FilterEvent };
//# sourceMappingURL=filter-event.js.map